var cpnBtn = document.getElementById("cpnBtn");
var cpnCode = document.getElementById("cpnCode");
var copyPastew = document.getElementById("copyPastew")

    copyPastew.onclick = function(){
      navigator.clipboard.writeText(cpnCode.innerHTML);
      cpnBtn.innerHTML ="Copied";
      setTimeout(function(){
          cpnBtn.innerHTML = "Tap to copy";
      }, 2000);
}